<template>
  <el-container class="layout">
    <!-- 侧边导航 -->
    <el-aside :width="isCollapse ? '64px' : '200px'" class="aside">
      <div class="logo" @click="toggleMenu">
        <i class="el-icon-s-operation"></i>
        <transition name="fade">
          <span v-if="!isCollapse">废旧金属后台</span>
        </transition>
      </div>

      <el-menu
        router
        :collapse="isCollapse"
        background-color="#1f2d3d"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <!-- 建议首页也走 /home/index，避免只有空壳 -->
        <el-menu-item index="/home/index">
          <i class="el-icon-house"></i>
          <span slot="title">首页</span>
        </el-menu-item>

        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-shopping-cart-2"></i>
            <span slot="title">订单管理</span>
          </template>
          <el-menu-item index="/home/order">订单审核</el-menu-item>
          <el-menu-item index="/home/appointment">预约受理</el-menu-item>
        </el-submenu>

        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-money"></i>
            <span slot="title">财务管理</span>
          </template>
          <el-menu-item index="/home/finance">提现审核</el-menu-item>
        </el-submenu>

        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span slot="title">参数设置</span>
          </template>
          <el-menu-item index="/home/metalType">金属类型</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <!-- 右侧内容 -->
    <el-container>
      <!-- 顶部 -->
      <el-header class="header">
        <div class="left">
          <i
            class="el-icon-s-fold toggle-btn"
            @click="toggleMenu"
            :class="{ rotated: isCollapse }"
          ></i>
          <span class="sys-title">废旧金属回收后台</span>
        </div>

        <div class="right">
          <el-dropdown>
            <span class="el-dropdown-link">
              博乐润景<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logout">
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="main">
        <Breadcrumb />
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'

export default {
  name: 'HomeLayout',
  components: { Breadcrumb }, // ✅ 组件应该写在这里，不是 data 里
  data() {
    return {
      isCollapse: false
    }
  },
  methods: {
    toggleMenu() {
      this.isCollapse = !this.isCollapse
    },
    logout() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
}

/* 左侧抽屉导航 */
.aside {
  background-color: #1f2d3d;
  color: #fff;
  transition: width 0.3s ease;
  overflow: hidden;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  border-bottom: 1px solid #2c3e50;
}

.logo i {
  font-size: 20px;
  margin-right: 6px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 顶部栏 */
.header {
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
}

.left {
  display: flex;
  align-items: center;
}
.sys-title {
  margin-left: 10px;
  font-weight: 600;
  font-size: 16px;
  color: #333;
}

/* 汉堡按钮 */
.toggle-btn {
  font-size: 20px;
  color: #333;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.toggle-btn.rotated {
  transform: rotate(180deg);
}

/* 主体内容区 */
.main {
  background: #f0f2f5;
  padding: 20px;
  height: calc(100vh - 60px);
  overflow: auto;
}
</style>
